import { render, staticRenderFns } from "./BStaticInput.vue?vue&type=template&id=6661076e"
import script from "./BStaticInput.vue?vue&type=script&lang=js"
export * from "./BStaticInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports